<div class="common-modal__container">
  <div class="common-modal__header">
		<span
			class="common-modal__text-header"
			[afTranslate]="'migration-data.dialog-title'">
			_Migración de datos
    </span>
  </div>
  <span class="common-modal__content-header-info">
		{{migrationData.headerInfo}}
	</span>
	<div class="common-modal__form-container-extend-row">
		<button
			(click)="handleAccept('template')"
			class="common-button-card__container-action">
			<div class="common-button-card__title-container-action">
				<div
					[afTranslate]="'migration-data.download-template'"
					class="common-button-card__inner-title-action">
					_Descargar plantilla
				</div>
				<i class="lf-icon-download common-icon__xl">
				</i>
			</div>
			<span class="common-button-card__description">
				{{migrationData.templateDesc}}
			</span>
		</button>
		<button
			(click)="handleAccept('import')"
			class="common-button-card__container-action">
			<div class="common-button-card__title-container-action">
				<div class="common-button-card__inner-title-action">
					{{migrationData.importTitle}}
				</div>
				<i class="lf-icon-up-file common-icon__xl">
				</i>
			</div>
			<span class="common-button-card__description">
				{{migrationData.importDesc}}
			</span>
		</button>
		<button
			(click)="handleAccept('export')"
			class="common-button-card__container-action">
			<div class="common-button-card__title-container-action">
				<div class="common-button-card__inner-title-action">
					{{migrationData.exportTitle}}
				</div>
				<i class="lf-icon-send common-icon__xl">
				</i>
			</div>
			<span class="common-button-card__description">
				{{migrationData.exportDesc}}
			</span>
		</button>
	</div>
	<div class="common-modal__footer">
		<button
			(click)="handleDismiss()"
			class="common-button__text">
			<span
				[afTranslate]="'common.close'"
				class="common-button__text-title">
				_Cerrar
			</span>
		</button>
	</div>
</div>
